import * as React from "react";
import { useState, useEffect } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useTheme } from "@emotion/react";
import { useApp } from "contexts/AppContext";
import axios from "axios-config";
import "./AuthPage.css";
import AuthCard from "./AuthCard";
import Cookies from "js-cookie";

const AuthPage = () => {
  const [register, setRegister] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const theme = useTheme();

  document.body.style.backgroundColor = theme.palette.lightBlue.main;

  const PublicRoute = ({ children }) => {
    const location = useLocation();
    const { state } = useApp();
    // While auth state is loading, render nothing or a loading spinner.
    if (state.loading) return null;
    return !state.isAuth ? (
      children
    ) : (
      <Navigate to="/" replace state={{ from: location }} />
    );
  };

  return (
    <PublicRoute>
      <AuthCard>
        <Outlet />
      </AuthCard>
    </PublicRoute>
  );
};

export default AuthPage;
